module.exports = __webpack_public_path__ + "img/fity.19334ca5.png";